<template>
  <div class="processPage">
    <div class="topBlock">
      <div class="toolBar">
        <div class="textBox">流程管控</div>
        <div>
            <!-- <el-button type="primary" @click.native.prevent="add" size="small"
             v-if="!showSort">+新增流程</el-button
          > -->
          <!-- <el-button type="info" @click.native.prevent="reSort" size="small"
            >{{sortText}}</el-button
          > -->
        
        </div>
      </div>
    </div>
    <div class="tableBox">
      <el-table
        :data="processData"
        border
        :height="'500'"
       
        :cell-class-name="'cellClass'"
        :stripe="true"
         v-loading = "isLoading"
      >
        <el-table-column :prop="'index'" :key="''"  width="80" align="center" :label="''" v-if="showSort">
            <!-- <template slot-scope="scope">
                <span title="降序" v-if="scope.row.index!=1" @click="low(scope.row.index)">
                <i class="el-icon-top" ></i>
                </span>
                <span title="升序" v-if="scope.row.index!=processData.length"  @click="up(scope.row.index)">
                <i class="el-icon-bottom"></i>
                </span>
            </template> -->
        </el-table-column>
       <!-- <el-table-column :prop="'index'" :key="'index'" :label="'顺序'">
          <template slot-scope="scope">
           <span>
              <i class="el-icon-top"></i>
              <i class="el-icon-bottom"></i>
            </span>
           <span style="margin-left: 10px">{{ scope.row.index }}</span>
          </template>
        </el-table-column>  -->
        <el-table-column
          v-for="(item, index) in processHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
        <!-- <el-table-column label="操作" width="240" v-if="!showSort">
          <template slot-scope="scope">
            <el-button
              @click="editProcess(scope.$index, createPlanData)"
              plain
              size="small"
            >
              修改
            </el-button>

            <el-popconfirm
              title="确定删除此条记录吗？"
              @confirm="deleteProcess(scope.$index, createPlanData)"
            >
              <el-button slot="reference" type="danger" size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <add-process
      v-if="showPop"
      @close="close"
      @save="save"
      :rowData="rowData"
    />
  </div>
</template>

<script>
import addProcess from "./pop/addProcess.vue";
import {getProcessList,setProcess,delProcess,addPro} from "@/api/process"
import { Message } from 'element-ui';
export default {
  name: "processIndexPage",
  components: { addProcess },
  data() {
    return {
     showSort:false,
      showPop: false,
      isLoading:false,
      formData: "",
      sortText:"重新排序",
      rowData: "",
      processHead: [
         { prop: "index", label: "工艺顺序" },
        { prop: "name", label: "流程名称" }],
      processData: [
        // {
        //   index: 1,
        //   name: "投产",
        // },
        // {
        //   index: 2,
        //   name: "放电",
        // },
        // {
        //   index: 3,
        //   name: "成型",
        // },
        // {
        //   index: 4,
        //   name: "品控",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },
        // {
        //   index: 5,
        //   name: "入库",
        // },

      ],
    };
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      let that=this
      that.isLoading=true
      getProcessList().then(res=>{
        that.processData=res.processList
        that.isLoading=false
      }).catch(e=>{
        that.isLoading=false
      })
    },
    close() {
      this.showPop = false;

    },
    save(data) {
      // this.formData = data;
      let that=this
      data.id=this.rowData.id
      if(this.rowData.name){
        //修改
        setProcess(data).then(res=>{
          Message.success("修改成功")
          that.getList()
        }).catch(e=>{

        })
      }else{
        //新增
        addPro(data).then(res=>{
          
          Message.success("新增流程成功")
           that.getList()
        }).catch(e=>{

        })
      }

      this.close();
    },

    editProcess(index, data) {
      this.rowData = this.processData[index];
      this.showPop = true;
    },
    add() {
      let maxIndex=this.getMaxIndex()
      console.log(this.processData,maxIndex+1)
      this.rowData={index:maxIndex+1}
      this.showPop = true;
    },
    getMaxIndex(){
      let i=0
      this.processData.map(item=>{
        if(item['index']>i){
          i=item['index']
        }
      })
      return i
    },

    deleteProcess(index, data) {
      let that=this
      delProcess({id:this.processData[index].id}).then(res=>{
        Message.success("删除成功")
        that.getList()
      }).catch(e=>{

      })
    },
 
  },
};
</script>

<style lang="less">
.processPage {
  .topBlock {
    .toolBar {
      display: flex;
      justify-content: space-between;
      padding: 8px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/processManage/index.vue